import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type AccessoryType = {
  __typename?: 'AccessoryType';
  finishes?: Maybe<Array<Maybe<Finish>>>;
  shapes?: Maybe<Array<Maybe<Shape>>>;
};

export type AddressInterface = {
  /** The city or town */
  city?: Maybe<Scalars['String']['output']>;
  /** The company */
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CartAddressCountry>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The last name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  /** An string that defines the street number and name */
  street?: Maybe<Scalars['String']['output']>;
  /** The second line of the street address */
  street2?: Maybe<Scalars['String']['output']>;
  /** The telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  vatId?: Maybe<Scalars['String']['output']>;
};

/** List of autocomplete results based on user input */
export type AddressSuggestionDetailResult = {
  __typename?: 'AddressSuggestionDetailResult';
  city: Scalars['String']['output'];
  number: Scalars['String']['output'];
  numberAddition?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

/** List of autocomplete results based on user input */
export type AddressSuggestionResult = {
  __typename?: 'AddressSuggestionResult';
  context: Scalars['String']['output'];
  description: Scalars['String']['output'];
  highlights: Scalars['String']['output'];
  label: Scalars['String']['output'];
  precision: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A bucket that contains information for each filterable option (such as price, category ID, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']['output'];
  /** Description of the aggregation group */
  description?: Maybe<Scalars['String']['output']>;
  /** Description exists in Pimcore */
  hasDescription: Scalars['Boolean']['output'];
  /** The aggregation display name. */
  label: Scalars['String']['output'];
  /** Array of options for the aggregation. */
  options: Array<AggregationOption>;
};

export type AggregationOption = {
  __typename?: 'AggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Aggregation option display label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

export type AppliedFinish = {
  __typename?: 'AppliedFinish';
  finish: Finish;
  option: FinishOption;
  side: FinishSide;
};

export type ApplyForBusinessAccountInput = {
  addressInput: CustomerAddressInput;
  company: Scalars['String']['input'];
  dob: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  legalFormType: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  taxvat: Scalars['String']['input'];
};

export type Asset = {
  __typename?: 'Asset';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type AvailablePaymentMethod = PaymentMethodInterface & {
  __typename?: 'AvailablePaymentMethod';
  code: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<PaymentOption>>>;
  paymentCharge?: Maybe<Scalars['Float']['output']>;
  paymentChargeTotal: Money;
  paymentChargeType?: Maybe<PaymentChargeEnum>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AvailableShippingMethod = ShippingMethodInterface & {
  __typename?: 'AvailableShippingMethod';
  /** Check if the user can select a date */
  datesEnabled: Scalars['Boolean']['output'];
  /** Available delivery dates for the shipping method */
  deliveryDates?: Maybe<Array<Scalars['String']['output']>>;
  /** Delivery instructions comment */
  deliveryInstructionsComment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** First available delivery date */
  firstAvailableDeliveryDate: Scalars['String']['output'];
  /** Check if delivery instructions are available */
  hasDeliveryInstructions: Scalars['Boolean']['output'];
  /** Check if dates are available */
  hasSelectableDate: Scalars['Boolean']['output'];
  /** Last available delivery date */
  lastAvailableDeliveryDate: Scalars['String']['output'];
  /** A shipping method code associated with a carrier. */
  methodCode: Scalars['String']['output'];
  /** The label for the method code. */
  methodTitle?: Maybe<Scalars['String']['output']>;
  /** Deprecated */
  offsetLabel?: Maybe<Scalars['String']['output']>;
  /** Get the opening hours of take away location */
  openingHours?: Maybe<Scalars['String']['output']>;
  /** The cost of shipping using this shipping method, including tax */
  price: Money;
};

export type BillingAddressInput = {
  address?: InputMaybe<CartAddressInput>;
  cartId: Scalars['ID']['input'];
  customerAddressId?: InputMaybe<Scalars['ID']['input']>;
};

export type BillingCartAddress = AddressInterface & {
  __typename?: 'BillingCartAddress';
  /** The city or town */
  city?: Maybe<Scalars['String']['output']>;
  /** The company */
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CartAddressCountry>;
  customerAddressId?: Maybe<Scalars['Int']['output']>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The last name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  /** The telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  vatId?: Maybe<Scalars['String']['output']>;
};

export type BloggersContactInput = {
  agreement?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productType: Scalars['String']['input'];
  socialMedia: Array<SocialMediaInputType>;
  tel: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum BusinessStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type CabinetSpecs = {
  __typename?: 'CabinetSpecs';
  data: Array<CabinetSpecsData>;
  heading: Scalars['String']['output'];
};

export type CabinetSpecsData = {
  __typename?: 'CabinetSpecsData';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Cart = {
  __typename?: 'Cart';
  appliedCoupon?: Maybe<Scalars['String']['output']>;
  availablePaymentMethods: Array<AvailablePaymentMethod>;
  billingAddress: BillingCartAddress;
  cartGroup: Array<CartGroup>;
  crosssellProducts: ProductPagination;
  customerComment?: Maybe<Scalars['String']['output']>;
  customerCompany?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerInvoiceEmail?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  customerTaxvat?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVirtual?: Maybe<Scalars['Boolean']['output']>;
  items: Array<CartItem>;
  orderComment?: Maybe<Scalars['String']['output']>;
  orderNewsletter?: Maybe<Scalars['Boolean']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  selectedPaymentMethod?: Maybe<SelectedPaymentMethod>;
  shippingAddress: ShippingCartAddress;
  shippingComment?: Maybe<Scalars['String']['output']>;
  totalQuantity: Scalars['Int']['output'];
  totals: CartTotals;
  updatedAt: Scalars['String']['output'];
  useRestPieces: Scalars['Boolean']['output'];
};


export type CartCrosssellProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type CartAddressCountry = {
  __typename?: 'CartAddressCountry';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type CartAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type CartAddressRegion = {
  __typename?: 'CartAddressRegion';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type CartGroup = {
  __typename?: 'CartGroup';
  /** cart group code */
  id: Scalars['String']['output'];
  /** Name of the cart group */
  name: Scalars['String']['output'];
  /** Link to cart group type */
  url?: Maybe<Scalars['String']['output']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  children: Array<CartItem>;
  description?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isOptimized: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderData?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CartItem>;
  product?: Maybe<Product>;
  quantity: Scalars['Int']['output'];
  reservedUntil?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<ItemSpecifications>;
  totals: CartItemTotals;
};

export type CartItemInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  type?: InputMaybe<CartItemTypeEnum>;
};

export type CartItemSortOrderInput = {
  id: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type CartItemTotals = {
  __typename?: 'CartItemTotals';
  price: Money;
  rowTotal: Money;
};

export enum CartItemTypeEnum {
  Child = 'CHILD',
  Default = 'DEFAULT'
}

export type CartQuote = {
  __typename?: 'CartQuote';
  cartGroup: Array<CartGroup>;
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incrementId?: Maybe<Scalars['String']['output']>;
  isSalable: Scalars['Boolean']['output'];
  products: Array<CartQuoteProduct>;
  projectUrl?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Money>;
  totalPrice: Money;
  totalQuantity: Scalars['Int']['output'];
};

export type CartQuoteProduct = CartItem | OrderItem;

export type CartTotals = {
  __typename?: 'CartTotals';
  discount: PriceLabel;
  grandTotal: PriceLabel;
  paymentCharge: PriceLabel;
  shipping: PriceLabel;
  subTotal: PriceLabel;
  tax: PriceLabel;
  taxPercentage: Scalars['Float']['output'];
};

export type Category = {
  __typename?: 'Category';
  children: Array<Category>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['Int']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  hrefLang: Array<HrefLang>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isUsedForSeo?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  /** Meta Description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  /** Meta Title */
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent: Category;
  parents: Array<Category>;
  path?: Maybe<Scalars['String']['output']>;
  requestPath?: Maybe<Scalars['String']['output']>;
  seoContent?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  /** URL KEY */
  urlKey?: Maybe<Scalars['String']['output']>;
  urlPath?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  message: Scalars['String']['output'];
  /** Flag if the form is send successfully */
  success: Scalars['Boolean']['output'];
};

export type ContactInput = {
  call_time?: InputMaybe<Scalars['String']['input']>;
  com_preference?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  description_type?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  name: Scalars['String']['input'];
  order_number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  product_depth?: InputMaybe<Scalars['Int']['input']>;
  product_height?: InputMaybe<Scalars['Int']['input']>;
  product_materials?: InputMaybe<Scalars['String']['input']>;
  product_thickness?: InputMaybe<Scalars['Int']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  product_urls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_width?: InputMaybe<Scalars['Int']['input']>;
  response_time?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  solution_other?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ContactSettings = {
  __typename?: 'ContactSettings';
  subjects?: Maybe<Array<Maybe<ContactSubject>>>;
};

export type ContactSubject = {
  __typename?: 'ContactSubject';
  category?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename?: 'Country';
  availableRegions: Array<Region>;
  fullNameLocale: Scalars['String']['output'];
  /** The unique ID for a Country object. */
  id: Scalars['ID']['output'];
  regionRequired: Scalars['Boolean']['output'];
  threeLetterAbbreviation: Scalars['String']['output'];
  twoLetterAbbreviation: Scalars['String']['output'];
};

export type CreateCustomerInput = {
  /** The customer's date of birth */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email */
  email: Scalars['String']['input'];
  /** The customer's first name */
  firstname: Scalars['String']['input'];
  /** The customer's gender */
  gender?: InputMaybe<Gender>;
  /** The customer's last name */
  lastname: Scalars['String']['input'];
  /** The customer's password */
  password: Scalars['String']['input'];
};

export type CreateSharableCartInput = {
  cartId: Scalars['ID']['input'];
};

export type CreateShareCodeInput = {
  data: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type CreditMemo = {
  __typename?: 'CreditMemo';
  id: Scalars['ID']['output'];
};

/** The list of available currency codes */
export enum CurrencyEnum {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azm = 'AZM',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Buk = 'BUK',
  Bwp = 'BWP',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gek = 'GEK',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gqe = 'GQE',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nic = 'NIC',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Rhd = 'RHD',
  Rol = 'ROL',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Skk = 'SKK',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Std = 'STD',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmm = 'TMM',
  Tnd = 'TND',
  Top = 'TOP',
  Trl = 'TRL',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Veb = 'VEB',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmk = 'ZMK',
  Zwd = 'ZWD'
}

/** Customer defines the customer name and address and other details */
export type Customer = {
  __typename?: 'Customer';
  /** An array containing the customer's shipping and billing addresses */
  addresses: Array<CustomerAddress>;
  businessStatus?: Maybe<BusinessStatus>;
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's date of birth */
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  /** The customer's gender */
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  legalFormType?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<CustomerOrderPagination>;
  phone?: Maybe<Scalars['String']['output']>;
  projects: CustomerProjectPagination;
  registrarName?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  taxvat?: Maybe<Scalars['String']['output']>;
  /** The customer's wishlist */
  wishlist?: Maybe<Wishlist>;
};


/** Customer defines the customer name and address and other details */
export type CustomerDobArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Customer defines the customer name and address and other details */
export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Customer defines the customer name and address and other details */
export type CustomerProjectsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CustomerProjectStatus>;
};

/** CustomerAddress contains detailed information about a customer's billing and shipping addresses */
export type CustomerAddress = AddressInterface & {
  __typename?: 'CustomerAddress';
  /** The city or town */
  city?: Maybe<Scalars['String']['output']>;
  /** The company */
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CartAddressCountry>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates whether the address is the default billing address */
  isDefaultBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address is the default shipping address */
  isDefaultShipping?: Maybe<Scalars['Boolean']['output']>;
  /** A label that the customer can assign to the address */
  label?: Maybe<Scalars['String']['output']>;
  /** The last name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  /** The telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  vatId?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressInput = {
  /** The city or town */
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  /** The first name of the person associated with the shipping/billing address */
  firstname: Scalars['String']['input'];
  isDefaultBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the address */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the person associated with the shipping/billing address */
  lastname: Scalars['String']['input'];
  /** The customer's ZIP or postal code */
  postcode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  /** An string that defines the street number and name */
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** Contains details about each of the customer's orders */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  /** The billing address for the order */
  billingAddress?: Maybe<OrderAddress>;
  cartQuote?: Maybe<CartQuote>;
  creditDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** A list of credit memos for the order */
  creditMemos: Array<CreditMemo>;
  /** A field that can output a date in all sorts of ways. */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** The email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  incrementId: Scalars['ID']['output'];
  invoiceDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** A list of invoices for the order */
  invoices: Array<Invoice>;
  /** Whether the order is editable */
  isEditable: Scalars['Boolean']['output'];
  items: Array<OrderItem>;
  /** A field that can output a date in all sorts of ways. */
  orderDate?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The selected payment method for the order */
  selectedPaymentMethod?: Maybe<SelectedPaymentMethod>;
  shipmentDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** A list of shipments for the order */
  shipments: Array<Shipment>;
  /** The shipping address for the order */
  shippingAddress?: Maybe<OrderAddress>;
  shippingDescription?: Maybe<Scalars['String']['output']>;
  /** The current status of the order */
  status?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<Scalars['String']['output']>;
  /** The total quantity of all products in the order */
  totalQtyOrdered: Scalars['Int']['output'];
  /** Contains totals of the customer's orders */
  totals: OrderTotals;
  tracking: Array<Tracking>;
};


/** Contains details about each of the customer's orders */
export type CustomerOrderDeliveryDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Contains details about each of the customer's orders */
export type CustomerOrderOrderDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerOrderPagination = {
  __typename?: 'CustomerOrderPagination';
  /** Current page of the cursor */
  currentPage: Scalars['Int']['output'];
  /** Determines if cursor has more pages after the current page */
  hasMorePages: Scalars['Boolean']['output'];
  /** List of items on the current page */
  items: Array<CustomerOrder>;
  /** The last page (number of pages) */
  lastPage: Scalars['Int']['output'];
  /** Number of items returned per page */
  perPage: Scalars['Int']['output'];
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export type CustomerProject = {
  __typename?: 'CustomerProject';
  createdAt: Scalars['String']['output'];
  customer: Customer;
  id: Scalars['ID']['output'];
  items: CustomerProjectItemPagination;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: CustomerProjectStatus;
  updatedAt: Scalars['String']['output'];
};

export type CustomerProjectInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: CustomerProjectStatus;
};

export type CustomerProjectItem = {
  __typename?: 'CustomerProjectItem';
  id: Scalars['ID']['output'];
  orderData?: Maybe<Scalars['String']['output']>;
  product: Product;
  quantity: Scalars['Int']['output'];
  specs?: Maybe<ItemSpecifications>;
};

export type CustomerProjectItemInput = {
  orderData: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CustomerProjectItemPagination = {
  __typename?: 'CustomerProjectItemPagination';
  /** Current page of the cursor */
  currentPage: Scalars['Int']['output'];
  /** Determines if cursor has more pages after the current page */
  hasMorePages: Scalars['Boolean']['output'];
  /** List of items on the current page */
  items: Array<CustomerProjectItem>;
  /** The last page (number of pages) */
  lastPage: Scalars['Int']['output'];
  /** Number of items returned per page */
  perPage: Scalars['Int']['output'];
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export type CustomerProjectPagination = {
  __typename?: 'CustomerProjectPagination';
  /** Current page of the cursor */
  currentPage: Scalars['Int']['output'];
  /** Determines if cursor has more pages after the current page */
  hasMorePages: Scalars['Boolean']['output'];
  /** List of items on the current page */
  items: Array<CustomerProject>;
  /** The last page (number of pages) */
  lastPage: Scalars['Int']['output'];
  /** Number of items returned per page */
  perPage: Scalars['Int']['output'];
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export enum CustomerProjectStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED'
}

export type CustomerService = {
  __typename?: 'CustomerService';
  /** An information message to display */
  closeMessage: Scalars['String']['output'];
  /** The time when the customer service closes */
  closeTime: Scalars['String']['output'];
  /** A random image of a customer service employee */
  image?: Maybe<Scalars['String']['output']>;
  /** The status of the customer service */
  isOpen: Scalars['Boolean']['output'];
  /** The time when the customer service opens */
  openTime: Scalars['String']['output'];
};

export type CustomerToken = {
  __typename?: 'CustomerToken';
  token?: Maybe<Scalars['String']['output']>;
};

/** Contains details about customer's vat number */
export type CustomerVat = {
  __typename?: 'CustomerVat';
  companyName?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type Dimensions = {
  __typename?: 'Dimensions';
  depth: Scalars['String']['output'];
  height: Scalars['String']['output'];
  width: Scalars['String']['output'];
};

export type EdgeBand = {
  __typename?: 'EdgeBand';
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  minOrderLength: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId: Scalars['ID']['output'];
  price: Money;
  sku: Scalars['String']['output'];
  thickness: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type EdgeBandPagination = {
  __typename?: 'EdgeBandPagination';
  /** Current page of the cursor */
  currentPage: Scalars['Int']['output'];
  /** Determines if cursor has more pages after the current page */
  hasMorePages: Scalars['Boolean']['output'];
  /** List of items on the current page */
  items: Array<EdgeBand>;
  /** The last page (number of pages) */
  lastPage: Scalars['Int']['output'];
  /** Number of items returned per page */
  perPage: Scalars['Int']['output'];
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export type EdgeBands = {
  __typename?: 'EdgeBands';
  collection: EdgeBandPagination;
  matching: Array<EdgeBand>;
};

export type EditOrderRequestInput = {
  addressType?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ordernumber: Scalars['String']['input'];
  restpieces_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
};

export type FacebookInformation = {
  __typename?: 'FacebookInformation';
  chatEnabled?: Maybe<Scalars['Boolean']['output']>;
  facebookLikes?: Maybe<Scalars['Int']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
};

export type FeeSpecification = {
  __typename?: 'FeeSpecification';
  attachments: Array<Scalars['String']['output']>;
};

export type Finish = {
  __typename?: 'Finish';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FinishOption = {
  __typename?: 'FinishOption';
  code: Scalars['String']['output'];
  data: Array<FinishOptionData>;
  image: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type FinishOptionData = {
  __typename?: 'FinishOptionData';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FinishSide = {
  __typename?: 'FinishSide';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  shortLabel: Scalars['String']['output'];
};

export type Furniture = {
  __typename?: 'Furniture';
  materials: Array<FurnitureMaterial>;
  prices: Array<FurniturePrice>;
  saleableProductId?: Maybe<Scalars['Int']['output']>;
};

export type FurnitureConstraint = {
  __typename?: 'FurnitureConstraint';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type FurnitureConstraints = {
  __typename?: 'FurnitureConstraints';
  depth: FurnitureConstraint;
  height: FurnitureConstraint;
  width: FurnitureConstraint;
};

export type FurnitureMaterial = {
  __typename?: 'FurnitureMaterial';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<Product>;
  thicknesses?: Maybe<Array<Maybe<FurnitureThickness>>>;
};

export type FurniturePrice = {
  __typename?: 'FurniturePrice';
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type FurnitureThickness = {
  __typename?: 'FurnitureThickness';
  name: Scalars['String']['output'];
  parts: FurnitureThicknessParts;
  sku: Scalars['String']['output'];
};

export type FurnitureThicknessPartData = {
  __typename?: 'FurnitureThicknessPartData';
  constraints: FurnitureConstraints;
  price: Scalars['Float']['output'];
  thickness: Scalars['String']['output'];
};

export type FurnitureThicknessParts = {
  __typename?: 'FurnitureThicknessParts';
  background: FurnitureThicknessPartData;
  door: FurnitureThicknessPartData;
  horizontal: FurnitureThicknessPartData;
  shelf: FurnitureThicknessPartData;
  vertical: FurnitureThicknessPartData;
};

export type FurnitureToolStepsType = {
  __typename?: 'FurnitureToolStepsType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GridPerPage = {
  __typename?: 'GridPerPage';
  /** Default value of per page. */
  default: Scalars['Int']['output'];
  /** Available per page values. */
  options: Array<Maybe<Scalars['Int']['output']>>;
};

export type HrefLang = {
  __typename?: 'HrefLang';
  href: Scalars['String']['output'];
  hreflang: Scalars['String']['output'];
};

export type ImageGalleryType = {
  __typename?: 'ImageGalleryType';
  alt: Scalars['String']['output'];
  src: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  downloadLink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  total: InvoiceTotal;
};

export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  grandTotal: Money;
  shipping: Money;
  subTotal: Money;
  tax: Money;
};

export type ItemSpecifications = FeeSpecification | PlasticSpecification | SheetFurnitureSpecification | TableSpecification | WoodCompleteRestSpecification | WoodCompleteSpecification | WoodSpecification;

export type KiyohInformation = {
  __typename?: 'KiyohInformation';
  reviewCount?: Maybe<Scalars['Float']['output']>;
  reviewUrl?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type KiyohReview = {
  __typename?: 'KiyohReview';
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  place?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['String']['output']>;
  reviewScore: Scalars['Int']['output'];
  totalScore: Scalars['Float']['output'];
};

export type KiyohReviewPagination = {
  __typename?: 'KiyohReviewPagination';
  /** Current page of the cursor */
  currentPage: Scalars['Int']['output'];
  /** Determines if cursor has more pages after the current page */
  hasMorePages: Scalars['Boolean']['output'];
  /** List of items on the current page */
  items: Array<KiyohReview>;
  /** The last page (number of pages) */
  lastPage: Scalars['Int']['output'];
  /** Number of items returned per page */
  perPage: Scalars['Int']['output'];
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export enum MergeMethod {
  Combine = 'COMBINE',
  KeepNew = 'KEEP_NEW'
}

/** A Money object defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money';
  /** A three-letter currency code, such as USD or EUR */
  currency: CurrencyEnum;
  display: PriceDisplay;
  excludingTax: Scalars['Float']['output'];
  includingTax: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCartQuoteToCart?: Maybe<Cart>;
  addCustomerProjectToCart: Cart;
  /** Add any type of product to the cart */
  addProductToCart: UpdateCartResult;
  addProductToWishlist?: Maybe<Wishlist>;
  applyCouponToCart: Cart;
  applyForBusinessAccount: Customer;
  /** Changes the password for the logged-in customer */
  changeCustomerPassword?: Maybe<Customer>;
  clearCart: Cart;
  /** Create customer account */
  createCustomer?: Maybe<Customer>;
  /** Create customer address */
  createCustomerAddress?: Maybe<Customer>;
  createCustomerProjectFromCart: CustomerProject;
  createCustomerProjectFromItem: CustomerProject;
  /** Creates an empty shopping cart for a guest or logged in user */
  createEmptyCart: Scalars['String']['output'];
  /** Creates a new CSV to import later */
  createImportCsv?: Maybe<Scalars['String']['output']>;
  createSharableCart?: Maybe<Scalars['String']['output']>;
  createShareCode: ShareCode;
  /** Delete customer address */
  deleteCustomerAddress?: Maybe<Customer>;
  /** Delete customer project */
  deleteCustomerProject: CustomerProject;
  /** Sends a ticket to Freshdesk for the order edit form. */
  editOrderRequest?: Maybe<Contact>;
  /** Retrieve the customer token */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Merges the source cart into the destination cart */
  mergeCarts: Cart;
  optimizeItem: Cart;
  placeOrder: PlaceOrderOutput;
  /** Sends a alert when product is back in stock. */
  productAlert?: Maybe<Contact>;
  removeCouponFromCart: Cart;
  removeItemFromCart: UpdateCartResult;
  removeProductFromWishlist?: Maybe<Wishlist>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using requestPasswordResetEmail. */
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Sends a email to the customer service for bloggers form */
  sendBloggersContact?: Maybe<Contact>;
  /** Send contact form and add FD ticket. */
  sendContact?: Maybe<Contact>;
  /** Sends a ticket to Freshdesk for the order edit form. */
  sendStylistContact?: Maybe<Contact>;
  setBillingAddressOnCart: Cart;
  setCustomerEmailOnCart: Cart;
  setPaymentMethodOnCart: Cart;
  setShippingAddressOnCart: Cart;
  setShippingMethodOnCart: Cart;
  toggleUseRestPieces: Cart;
  /** Update the item in the cart */
  updateCartItem: UpdateCartResult;
  /** Update the sort order of items in the cart */
  updateCartSortOrder: Cart;
  /** Update the customer's personal information */
  updateCustomer?: Maybe<Customer>;
  /** Update customer address */
  updateCustomerAddress?: Maybe<Customer>;
  /** Update the customer's email */
  updateCustomerEmail?: Maybe<Customer>;
  updateCustomerProject: CustomerProject;
  updateCustomerProjectItem: CustomerProjectItem;
  /** Update the orderdata of the item */
  updateOrderData: UpdateCartResult;
  /** Validate the customer's VAT number */
  validateCustomerVat?: Maybe<CustomerVat>;
};


export type MutationAddCartQuoteToCartArgs = {
  cartId: Scalars['ID']['input'];
  cartQuote: Scalars['String']['input'];
  mergeMethod: MergeMethod;
};


export type MutationAddCustomerProjectToCartArgs = {
  cartId: Scalars['ID']['input'];
  method?: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationAddProductToCartArgs = {
  input: UpdateCartInput;
};


export type MutationAddProductToWishlistArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationApplyCouponToCartArgs = {
  cartId: Scalars['ID']['input'];
  couponCode: Scalars['String']['input'];
};


export type MutationApplyForBusinessAccountArgs = {
  input: ApplyForBusinessAccountInput;
};


export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationClearCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};


export type MutationCreateCustomerProjectFromCartArgs = {
  cartId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCustomerProjectFromItemArgs = {
  cartItem: CartItemInput;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateImportCsvArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationCreateSharableCartArgs = {
  input: CreateSharableCartInput;
};


export type MutationCreateShareCodeArgs = {
  input: CreateShareCodeInput;
};


export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditOrderRequestArgs = {
  input: EditOrderRequestInput;
};


export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMergeCartsArgs = {
  destinationCartId: Scalars['ID']['input'];
  sourceCartId: Scalars['ID']['input'];
};


export type MutationOptimizeItemArgs = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationPlaceOrderArgs = {
  input: PlaceOrderInput;
};


export type MutationProductAlertArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRemoveCouponFromCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationRemoveItemFromCartArgs = {
  input: UpdateCartInput;
};


export type MutationRemoveProductFromWishlistArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationRequestPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};


export type MutationSendBloggersContactArgs = {
  input: BloggersContactInput;
};


export type MutationSendContactArgs = {
  input: ContactInput;
};


export type MutationSendStylistContactArgs = {
  input: StylistContactInput;
};


export type MutationSetBillingAddressOnCartArgs = {
  input: BillingAddressInput;
};


export type MutationSetCustomerEmailOnCartArgs = {
  cartId: Scalars['ID']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  taxvat?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetPaymentMethodOnCartArgs = {
  input: SetPaymentMethodOnCartInput;
};


export type MutationSetShippingAddressOnCartArgs = {
  input: ShippingAddressInput;
};


export type MutationSetShippingMethodOnCartArgs = {
  input: SetShippingMethodOnCartInput;
};


export type MutationToggleUseRestPiecesArgs = {
  cartId: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationUpdateCartItemArgs = {
  input: UpdateCartInput;
};


export type MutationUpdateCartSortOrderArgs = {
  input: UpdateCartSortOrderInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['ID']['input'];
  input: CustomerAddressInput;
};


export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUpdateCustomerProjectArgs = {
  id: Scalars['ID']['input'];
  input: CustomerProjectInput;
};


export type MutationUpdateCustomerProjectItemArgs = {
  id: Scalars['ID']['input'];
  input: CustomerProjectItemInput;
};


export type MutationUpdateOrderDataArgs = {
  input: UpdateOrderDataInput;
};


export type MutationValidateCustomerVatArgs = {
  cartId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

/** Dimensions of panel as used in Optimization without margins */
export type OptimizationDimensions = {
  __typename?: 'OptimizationDimensions';
  length: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type OptimizationItem = {
  __typename?: 'OptimizationItem';
  id: Scalars['String']['output'];
  length: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type OptimizationResult = {
  __typename?: 'OptimizationResult';
  boards: Array<OptimizationItem>;
  items: Array<OptimizationItem>;
  length: Scalars['Float']['output'];
  panelLength: Scalars['Float']['output'];
  panelWidth: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

/** OrderAddress contains detailed information about an order's billing and shipping addresses */
export type OrderAddress = AddressInterface & {
  __typename?: 'OrderAddress';
  /** The city or town */
  city?: Maybe<Scalars['String']['output']>;
  /** The company */
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CartAddressCountry>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The last name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  street?: Maybe<Scalars['String']['output']>;
  /** The second line of the street address */
  street2?: Maybe<Scalars['String']['output']>;
  /** The telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  vatId?: Maybe<Scalars['String']['output']>;
};

/** Checks if the order can be edited by the customer */
export type OrderEditable = {
  __typename?: 'OrderEditable';
  editable: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  children: Array<OrderItem>;
  description?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderData?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<ItemSpecifications>;
  totals: OrderItemTotals;
};

export type OrderItemTotals = {
  __typename?: 'OrderItemTotals';
  price: Money;
  rowTotal: Money;
};

/** Contains details about the order */
export type OrderSuccess = {
  __typename?: 'OrderSuccess';
  cartGroup: Array<CartGroup>;
  deliveryDate: Scalars['String']['output'];
  email: Scalars['String']['output'];
  incrementId: Scalars['ID']['output'];
  isTakeaway: Scalars['Boolean']['output'];
  items: Array<OrderItem>;
  projectUrl?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Money>;
  /** The shipping address for the order */
  shippingAddress?: Maybe<OrderAddress>;
  shippingDescription?: Maybe<Scalars['String']['output']>;
  store: StoreInformation;
  totals: OrderTotals;
};

/** Contains totals of the order */
export type OrderTotals = {
  __typename?: 'OrderTotals';
  discount: Money;
  grandTotal: Money;
  shipping: Money;
  /** Order subtotal including tax */
  subTotal: Money;
  tax: Money;
  taxPercentage: Scalars['Float']['output'];
  totalDue: Money;
  totalPaid: Money;
  totalRefunded: Money;
};

/** PageInfo provides navigation for the query response */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Specifies which page of results to return */
  currentPage: Scalars['Int']['output'];
  /** Specifies the maximum number of items to return */
  pageSize: Scalars['Int']['output'];
  /** Total items */
  totalCount: Scalars['Int']['output'];
  /** Total pages */
  totalPages: Scalars['Int']['output'];
};

export type PanelType = {
  __typename?: 'PanelType';
  finishes: Array<Finish>;
  shapes: Array<Shape>;
  variants?: Maybe<ProductPagination>;
};


export type PanelTypeVariantsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum PaymentChargeEnum {
  FixedValue = 'FIXED_VALUE',
  Percentage = 'PERCENTAGE'
}

export type PaymentMethodInput = {
  code: Scalars['String']['input'];
  optionSub?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodInterface = {
  code: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  paymentCharge?: Maybe<Scalars['Float']['output']>;
  paymentChargeTotal: Money;
  paymentChargeType?: Maybe<PaymentChargeEnum>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentOption = {
  __typename?: 'PaymentOption';
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optionId: Scalars['ID']['output'];
};

export type PlaceOrderInput = {
  cartId: Scalars['ID']['input'];
  orderComment?: InputMaybe<Scalars['String']['input']>;
  orderNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput';
  monduToken?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PlasticSpecification = {
  __typename?: 'PlasticSpecification';
  dimensionsHtml: Scalars['String']['output'];
  finishes: Array<AppliedFinish>;
  label?: Maybe<Scalars['String']['output']>;
  shape: Shape;
};

export enum PriceDisplay {
  Both = 'BOTH',
  ExcludingTax = 'EXCLUDING_TAX',
  IncludingTax = 'INCLUDING_TAX'
}

export type PriceLabel = {
  __typename?: 'PriceLabel';
  label: Scalars['String']['output'];
  price: Money;
};

export type Product = {
  __typename?: 'Product';
  alternativeProduct?: Maybe<Product>;
  appearance?: Maybe<Scalars['String']['output']>;
  /** Pas gordelomvang beperkingen toe van DPD. */
  applyBeltSize: Scalars['Boolean']['output'];
  associatedProducts: ProductPagination;
  attributeSet: Scalars['String']['output'];
  attributes: Array<ProductAttribute>;
  /** Brand */
  brand?: Maybe<Scalars['String']['output']>;
  cabinetOuterDepth?: Maybe<Scalars['String']['output']>;
  cabinetOuterHeight?: Maybe<Scalars['String']['output']>;
  cabinetOuterWidth?: Maybe<Scalars['String']['output']>;
  /** Category tree only to be used in product view */
  categories: Array<Category>;
  category?: Maybe<Category>;
  /** Color code */
  colorCode?: Maybe<Scalars['String']['output']>;
  configurable?: Maybe<Scalars['Boolean']['output']>;
  crosssellProducts: ProductPagination;
  customStock?: Maybe<Scalars['Int']['output']>;
  deliveryOffset?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<Scalars['String']['output']>;
  /** Depth */
  depth?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diyProjectCode?: Maybe<Scalars['String']['output']>;
  faqCategoryIds: Array<Scalars['ID']['output']>;
  fastestDeliveryDate?: Maybe<Scalars['String']['output']>;
  finalPrice: Money;
  /** Grain */
  grainType?: Maybe<Scalars['String']['output']>;
  groupedProductId?: Maybe<Scalars['String']['output']>;
  /** Height */
  height?: Maybe<Scalars['String']['output']>;
  /** Hover image */
  hoverImage?: Maybe<Scalars['String']['output']>;
  hrefLang: Array<HrefLang>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageBase?: Maybe<Scalars['String']['output']>;
  imageDetail?: Maybe<Scalars['String']['output']>;
  imageGallery: Array<ImageGalleryType>;
  imageLabel?: Maybe<Scalars['String']['output']>;
  isOnWishlist: Scalars['Boolean']['output'];
  isSalable?: Maybe<Scalars['Boolean']['output']>;
  jsonConfiguration?: Maybe<Scalars['String']['output']>;
  /** Headmaat */
  kopmaat?: Maybe<Scalars['String']['output']>;
  /** Label text for cat. page */
  labelCategoryPage?: Maybe<Scalars['String']['output']>;
  linksExist?: Maybe<Scalars['Int']['output']>;
  linksPurchasedSeparately: Scalars['Int']['output'];
  lowestPrice: Money;
  maxDimensions?: Maybe<Scalars['String']['output']>;
  /** Max. Length (mm) */
  maxLength: Scalars['String']['output'];
  /** Max. Width (mm) */
  maxWidth: Scalars['String']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  msrp?: Maybe<Scalars['Float']['output']>;
  msrpDisplayActualPriceType?: Maybe<Scalars['String']['output']>;
  msrpEnabled?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ncsColorCode?: Maybe<Scalars['String']['output']>;
  newsFromDate?: Maybe<Scalars['String']['output']>;
  newsToDate?: Maybe<Scalars['String']['output']>;
  /** Packaging unit */
  packagingUnit?: Maybe<Scalars['String']['output']>;
  pimImageBase?: Maybe<Scalars['String']['output']>;
  pimImageDetail?: Maybe<Scalars['String']['output']>;
  pimImageGallery?: Maybe<Scalars['String']['output']>;
  pmsColorCode?: Maybe<Scalars['String']['output']>;
  positiveNegative?: Maybe<Scalars['String']['output']>;
  price: Money;
  priceM2CompletePanel?: Maybe<Scalars['Float']['output']>;
  priceM2UncutPanel?: Maybe<Scalars['Float']['output']>;
  priceType: Scalars['Int']['output'];
  priceView: Scalars['String']['output'];
  productType?: Maybe<ProductType>;
  /** Dimension of unity */
  productUnit: Scalars['String']['output'];
  productionUnit?: Maybe<Scalars['String']['output']>;
  purchaseType?: Maybe<Array<Scalars['String']['output']>>;
  requestPath: Scalars['String']['output'];
  requiredOptions?: Maybe<Scalars['String']['output']>;
  sampleProduct?: Maybe<Product>;
  shipmentType: Scalars['Int']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** SKU */
  sku: Scalars['String']['output'];
  /** Small Image */
  smallImage?: Maybe<Scalars['String']['output']>;
  smallImageLabel?: Maybe<Scalars['String']['output']>;
  specialFromDate?: Maybe<Scalars['String']['output']>;
  specialPrice?: Maybe<Scalars['Float']['output']>;
  specialToDate?: Maybe<Scalars['String']['output']>;
  specificationSheets: Array<SpecificationSheet>;
  /** Standard length in mm */
  standardLength: Scalars['String']['output'];
  /** Standard width in mm */
  standardWidth: Scalars['String']['output'];
  /** Status */
  status: Scalars['String']['output'];
  stockMessage?: Maybe<Scalars['String']['output']>;
  stockPosition?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  /** Tax Class */
  taxClassId: Scalars['String']['output'];
  thickness?: Maybe<Scalars['String']['output']>;
  /** Thickness */
  thicknessOld?: Maybe<Array<Scalars['String']['output']>>;
  /** Thumbnail */
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailLabel?: Maybe<Scalars['String']['output']>;
  /** Top layer type */
  toplayerType?: Maybe<Scalars['String']['output']>;
  /** Variant */
  typeFinish?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['String']['output'];
  url: Scalars['String']['output'];
  urlKey?: Maybe<Scalars['String']['output']>;
  videoGallery: Array<Scalars['String']['output']>;
  weightType: Scalars['Int']['output'];
  /** Width */
  width?: Maybe<Scalars['String']['output']>;
  woodApplications?: Maybe<Scalars['String']['output']>;
  /** Explanation of wood type at cupboards */
  woodExplanationFurniture?: Maybe<Scalars['String']['output']>;
  /** Used wood */
  woodUsed?: Maybe<Scalars['String']['output']>;
};


export type ProductAssociatedProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductCrosssellProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasDescription: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  optionId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** ProductAttributeFilterInput defines the filters to be used in the search. A filter contains at least one attribute and the value(s) that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: Schroefkop */
  acc_bit_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Diameter */
  acc_diameter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Korrel */
  acc_sandpaper_grain?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Uitstraling */
  appearance?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Merk */
  brand?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter product by the unique ID for a CategoryInterface object. */
  category_id?: InputMaybe<Scalars['ID']['input']>;
  /** Attribute label: Kleur */
  color?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Kleurcode */
  color_code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Kleurnuance */
  color_shade?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Kern */
  core?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Levertijd */
  delivery_time?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Beschikbare vormen */
  finish_shapes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Beschikbare afwerkingen */
  finish_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Functioneel gebruik */
  general_application?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Kopmaat */
  kopmaat?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: NCS */
  ncs_color_code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Toepassing (klimaat) */
  outdoor?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: PMS */
  pms_color_code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Productie verwerkingsmethode */
  production_unit?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Afname type */
  purchase_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Zichtkwaliteit */
  quality_visual?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Sample service */
  sample_service?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Dikte */
  thickness?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Type toplaag */
  toplayer_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Behandeling voor gebruik */
  treatment_for_use?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Variant */
  type_finish?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter products by type (e.g. simple, grouped) */
  type_id?: InputMaybe<Scalars['String']['input']>;
  /** Attribute label: Plaatopbouw */
  wood_connection_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Structuur toplaag */
  wood_structure?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Attribute label: Houtsoort toplaag */
  wood_used?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProductAttributeSortInput = {
  /** Sort by Levertijd */
  delivery_time?: InputMaybe<SortInput>;
  /** Sort by Naam */
  name?: InputMaybe<SortInput>;
  /** Sort by Prijs */
  price?: InputMaybe<SortInput>;
};

export type ProductPagination = {
  __typename?: 'ProductPagination';
  /** Current page of the cursor */
  currentPage: Scalars['Int']['output'];
  /** Determines if cursor has more pages after the current page */
  hasMorePages: Scalars['Boolean']['output'];
  /** List of items on the current page */
  items: Array<Product>;
  /** The last page (number of pages) */
  lastPage: Scalars['Int']['output'];
  /** Number of items returned per page */
  perPage: Scalars['Int']['output'];
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export type ProductType = AccessoryType | PanelType | SheetFurnitureType | TableType;

export type Products = {
  __typename?: 'Products';
  /** Layered navigation aggregations */
  aggregations: Array<Aggregation>;
  /** An object that includes all the options for the grid per page filter */
  gridPerPage: ProductsPerPage;
  /** An array of products that match the specified search criteria. */
  items: Array<Product>;
  listMode: Scalars['String']['output'];
  /** An object that includes all the options for the list per page filter */
  listPerPage: ProductsPerPage;
  /** An object that includes the pageInfo and currentPage values specified in the query. */
  pageInfo: PageInfo;
  /** An object that includes the default sort field and all available sort fields. */
  sortFields: SortFields;
};

export type ProductsPerPage = {
  __typename?: 'ProductsPerPage';
  /** Default value of per page. */
  default: Scalars['Int']['output'];
  /** Available per page values. */
  options: Array<Maybe<Scalars['Int']['output']>>;
};

export type Query = {
  __typename?: 'Query';
  addressSuggestionDetail?: Maybe<AddressSuggestionDetailResult>;
  addressSuggestions?: Maybe<Array<Maybe<AddressSuggestionResult>>>;
  bestSellers?: Maybe<ProductPagination>;
  /** Calculate the price of an item */
  calculatePrice: Money;
  /** Returns information about shopping cart */
  cart?: Maybe<Cart>;
  cartQuote?: Maybe<CartQuote>;
  category?: Maybe<Category>;
  contactSettings?: Maybe<ContactSettings>;
  /** The countries query provides information for all countries. */
  countries: Array<Maybe<Country>>;
  /** The country query provides information for a single country. */
  country?: Maybe<Country>;
  customer?: Maybe<Customer>;
  /** Returns information about the customer shopping cart */
  customerCart: Cart;
  customerOrder?: Maybe<CustomerOrder>;
  customerProject?: Maybe<CustomerProject>;
  edgeBand?: Maybe<EdgeBand>;
  edgeBands?: Maybe<EdgeBands>;
  filterableAttributes: Array<Scalars['String']['output']>;
  furniture: Furniture;
  isEmailAvailable: Scalars['Boolean']['output'];
  kiyohReviews?: Maybe<KiyohReviewPagination>;
  orderEditable?: Maybe<OrderEditable>;
  /** Returns status information about order */
  orderStatus?: Maybe<CustomerOrder>;
  /** Returns information about a single order */
  orderSuccess?: Maybe<OrderSuccess>;
  product?: Maybe<Product>;
  products: Products;
  search?: Maybe<Products>;
  shareCode?: Maybe<ShareCode>;
  /** Returns information about available shipping methods */
  shippingInformation?: Maybe<Array<Maybe<ShippingInformation>>>;
  /** Handles server side tracking events for Google Analytics based on locale-specific configurations. */
  tracking: Scalars['Boolean']['output'];
  urlResolver?: Maybe<UrlResolverResult>;
  website: Website;
};


export type QueryAddressSuggestionDetailArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  context: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
};


export type QueryAddressSuggestionsArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
};


export type QueryBestSellersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculatePriceArgs = {
  data: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};


export type QueryCartArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCartQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomerOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEdgeBandArgs = {
  sku: Scalars['String']['input'];
};


export type QueryEdgeBandsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']['input'];
};


export type QueryKiyohReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderEditableArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryOrderStatusArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryOrderSuccessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductsArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QuerySearchArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryShareCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryTrackingArgs = {
  clientId: Scalars['String']['input'];
  events: Array<TrackingEventsInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUrlResolverArgs = {
  url: Scalars['String']['input'];
};

export type Region = {
  __typename?: 'Region';
  code: Scalars['String']['output'];
  /** The unique ID for a Region object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SelectedPaymentMethod = PaymentMethodInterface & {
  __typename?: 'SelectedPaymentMethod';
  code: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  option?: Maybe<PaymentOption>;
  paymentCharge?: Maybe<Scalars['Float']['output']>;
  paymentChargeTotal: Money;
  paymentChargeType?: Maybe<PaymentChargeEnum>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SelectedShippingCarrier = {
  __typename?: 'SelectedShippingCarrier';
  banner?: Maybe<Scalars['String']['output']>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrierCode: Scalars['String']['output'];
  /** The label for the carrier code. */
  carrierTitle?: Maybe<Scalars['String']['output']>;
  /** The description of the method */
  description?: Maybe<Scalars['String']['output']>;
  isTakeaway: Scalars['Boolean']['output'];
  method: SelectedShippingMethod;
};

export type SelectedShippingMethod = ShippingMethodInterface & {
  __typename?: 'SelectedShippingMethod';
  /** Check if the user can select a date */
  datesEnabled: Scalars['Boolean']['output'];
  /** Selected delivery date */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** Delivery instructions comment */
  deliveryInstructionsComment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** First available delivery date */
  firstAvailableDeliveryDate: Scalars['String']['output'];
  /** Check if delivery instructions are available */
  hasDeliveryInstructions: Scalars['Boolean']['output'];
  /** Check if dates are available */
  hasSelectableDate: Scalars['Boolean']['output'];
  /** Last available delivery date */
  lastAvailableDeliveryDate: Scalars['String']['output'];
  /** A shipping method code associated with a carrier. */
  methodCode: Scalars['String']['output'];
  /** The label for the method code. */
  methodTitle?: Maybe<Scalars['String']['output']>;
  /** Deprecated */
  offsetLabel?: Maybe<Scalars['String']['output']>;
  /** Get the opening hours of take away location */
  openingHours?: Maybe<Scalars['String']['output']>;
  /** The cost of shipping using this shipping method, including tax */
  price: Money;
};

export type SetPaymentMethodOnCartInput = {
  cartId: Scalars['ID']['input'];
  paymentMethod: PaymentMethodInput;
};

export type SetShippingMethodOnCartInput = {
  cartId: Scalars['ID']['input'];
  shippingComment?: InputMaybe<Scalars['String']['input']>;
  shippingMethod: ShippingMethodInput;
};

export type Shape = {
  __typename?: 'Shape';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ShareCode = {
  __typename?: 'ShareCode';
  code: Scalars['String']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  url: Scalars['String']['output'];
};

export type SheetFurnitureSpecification = {
  __typename?: 'SheetFurnitureSpecification';
  dimensions?: Maybe<Dimensions>;
  dimensionsHtml: Scalars['String']['output'];
  specs?: Maybe<CabinetSpecs>;
};

export type SheetFurnitureType = {
  __typename?: 'SheetFurnitureType';
  cabinetOuterDepth?: Maybe<Scalars['String']['output']>;
  cabinetOuterHeight?: Maybe<Scalars['String']['output']>;
  cabinetOuterWidth?: Maybe<Scalars['String']['output']>;
  diyProjectCode?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type Shipment = {
  __typename?: 'Shipment';
  id: Scalars['ID']['output'];
  tracking?: Maybe<ShipmentTracking>;
};

export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  carrier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ShippingAddressInput = {
  address?: InputMaybe<CartAddressInput>;
  cartId: Scalars['ID']['input'];
  customerAddressId?: InputMaybe<Scalars['ID']['input']>;
  sameAsBilling?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingCarrier = {
  __typename?: 'ShippingCarrier';
  banner?: Maybe<Scalars['String']['output']>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrierCode: Scalars['String']['output'];
  /** The label for the carrier code. */
  carrierTitle?: Maybe<Scalars['String']['output']>;
  /** The description of the method */
  description?: Maybe<Scalars['String']['output']>;
  isTakeaway: Scalars['Boolean']['output'];
  methods: Array<AvailableShippingMethod>;
};

export type ShippingCartAddress = AddressInterface & {
  __typename?: 'ShippingCartAddress';
  availableShippingMethods: Array<ShippingCarrier>;
  /** The city or town */
  city?: Maybe<Scalars['String']['output']>;
  /** The company */
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CartAddressCountry>;
  customerAddressId?: Maybe<Scalars['Int']['output']>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The last name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  sameAsBilling: Scalars['Boolean']['output'];
  selectedShippingMethod?: Maybe<SelectedShippingCarrier>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  /** The telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  vatId?: Maybe<Scalars['String']['output']>;
};

export type ShippingInformation = {
  __typename?: 'ShippingInformation';
  carrierCode: Scalars['String']['output'];
  carrierDescription?: Maybe<Scalars['String']['output']>;
  carrierName: Scalars['String']['output'];
};

export type ShippingMethodInput = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  methodCode: Scalars['String']['input'];
};

export type ShippingMethodInterface = {
  /** Check if the user can select a date */
  datesEnabled: Scalars['Boolean']['output'];
  /** Delivery instructions comment */
  deliveryInstructionsComment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** First available delivery date */
  firstAvailableDeliveryDate: Scalars['String']['output'];
  /** Check if delivery instructions are available */
  hasDeliveryInstructions: Scalars['Boolean']['output'];
  /** Check if dates are available */
  hasSelectableDate: Scalars['Boolean']['output'];
  /** Last available delivery date */
  lastAvailableDeliveryDate: Scalars['String']['output'];
  /** A shipping method code associated with a carrier. */
  methodCode: Scalars['String']['output'];
  /** The label for the method code. */
  methodTitle?: Maybe<Scalars['String']['output']>;
  /** Deprecated */
  offsetLabel?: Maybe<Scalars['String']['output']>;
  /** Get the opening hours of take away location */
  openingHours?: Maybe<Scalars['String']['output']>;
  /** The cost of shipping using this shipping method, including tax */
  price: Money;
};

export type SocialMediaInputType = {
  channel: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SortField = {
  __typename?: 'SortField';
  /** Label of sort field. */
  label: Scalars['String']['output'];
  /** Attribute code of sort field. */
  value: Scalars['String']['output'];
};

/** An object that includes the default sort field and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields';
  /** Default value of sort fields. */
  default: Scalars['String']['output'];
  /** Available sort fields. */
  options: Array<SortField>;
};

export enum SortInput {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecificationSheet = {
  __typename?: 'SpecificationSheet';
  element: Asset;
  variant?: Maybe<Scalars['String']['output']>;
};

export type StoreInformation = {
  __typename?: 'StoreInformation';
  addressValidationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The base url of the current store */
  baseUrl: Scalars['String']['output'];
  code: Scalars['ID']['output'];
  /** The name of the company */
  companyName?: Maybe<Scalars['String']['output']>;
  companyVideo?: Maybe<Scalars['String']['output']>;
  /** The available countries of the current store */
  countries: Array<Country>;
  /** The country of the current store */
  country: Country;
  /** The currency code of the current store */
  currency: Scalars['String']['output'];
  customerService: CustomerService;
  /** @deprecated Facebook is being deprecated */
  facebook?: Maybe<FacebookInformation>;
  isCheckModeEnabled: Scalars['Boolean']['output'];
  kiyoh: KiyohInformation;
  /** The language of the current store */
  language: Scalars['String']['output'];
  /** Two letter abbreviation of language of the current store */
  languageTwoLetterAbbreviation: Scalars['String']['output'];
  /** The locale of the current store */
  locale: Scalars['String']['output'];
  /** The name of the current store */
  name: Scalars['String']['output'];
  paymentMethods: Array<AvailablePaymentMethod>;
  /** The root category of the current store */
  rootCategory: Category;
  /** The timezone of the current store */
  timezone: Scalars['String']['output'];
};

export type StylistContactInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postal?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Scalars['String']['input']>;
};

export type TableSpecification = {
  __typename?: 'TableSpecification';
  dimensionsHtml: Scalars['String']['output'];
  finishes: Array<AppliedFinish>;
  shape: Shape;
  thickness: Scalars['String']['output'];
  topLayer: Scalars['String']['output'];
};

export type TableType = {
  __typename?: 'TableType';
  customTableToolJson?: Maybe<Scalars['String']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TrackingEventParamsInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TrackingEventsInput = {
  name: Scalars['String']['input'];
  params: Array<TrackingEventParamsInput>;
};

export type UpdateCartInput = {
  cartId: Scalars['ID']['input'];
  cartItem: CartItemInput;
};

export type UpdateCartResult = {
  __typename?: 'UpdateCartResult';
  cart: Cart;
  item: CartItem;
};

export type UpdateCartSortOrderInput = {
  cartId: Scalars['ID']['input'];
  cartItems: Array<InputMaybe<CartItemSortOrderInput>>;
};

export type UpdateCustomerInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  legalFormType?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrarName?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  taxvat?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderDataInput = {
  cartId: Scalars['ID']['input'];
  cartItemId: Scalars['ID']['input'];
  orderData: Scalars['String']['input'];
};

export type UrlResolverResult = {
  __typename?: 'UrlResolverResult';
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  permanent: Scalars['Boolean']['output'];
  redirect: Scalars['Boolean']['output'];
  type?: Maybe<UrlType>;
};

export enum UrlType {
  Bloggers = 'BLOGGERS',
  Brand = 'BRAND',
  BrandOverview = 'BRAND_OVERVIEW',
  BusinessOverview = 'BUSINESS_OVERVIEW',
  Category = 'CATEGORY',
  CustomerReviews = 'CUSTOMER_REVIEWS',
  CustomerServiceDetail = 'CUSTOMER_SERVICE_DETAIL',
  CustomerServiceOverview = 'CUSTOMER_SERVICE_OVERVIEW',
  CustomerServiceView = 'CUSTOMER_SERVICE_VIEW',
  DiyCategory = 'DIY_CATEGORY',
  DiyCategoryLanding = 'DIY_CATEGORY_LANDING',
  DiyDetail = 'DIY_DETAIL',
  DiyHome = 'DIY_HOME',
  DiyOverview = 'DIY_OVERVIEW',
  DiySend = 'DIY_SEND',
  FaqItem = 'FAQ_ITEM',
  Knowledge = 'KNOWLEDGE',
  KnowledgeOverview = 'KNOWLEDGE_OVERVIEW',
  Landing = 'LANDING',
  LandingOverview = 'LANDING_OVERVIEW',
  Post = 'POST',
  PostOverview = 'POST_OVERVIEW',
  Product = 'PRODUCT',
  StylistDetail = 'STYLIST_DETAIL',
  StylistOverview = 'STYLIST_OVERVIEW',
  Tips = 'TIPS',
  TipsOverview = 'TIPS_OVERVIEW',
  VideosDetail = 'VIDEOS_DETAIL',
  VideosOverview = 'VIDEOS_OVERVIEW'
}

export type VideosType = {
  __typename?: 'VideosType';
  ids?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Website = {
  __typename?: 'Website';
  /** The the available store views */
  available: Array<StoreInformation>;
  /** The current store view */
  current: StoreInformation;
};

export type Wishlist = {
  __typename?: 'Wishlist';
  id: Scalars['ID']['output'];
  products: Array<Product>;
};

export type WoodCompleteRestSpecification = {
  __typename?: 'WoodCompleteRestSpecification';
  dimensionsHtml: Scalars['String']['output'];
  shape: Shape;
};

export type WoodCompleteSpecification = {
  __typename?: 'WoodCompleteSpecification';
  optimizations: Array<OptimizationResult>;
  panelQuantity: Scalars['Int']['output'];
  shipBoards: Scalars['Boolean']['output'];
};

export type WoodSpecification = {
  __typename?: 'WoodSpecification';
  dimensionsHtml: Scalars['String']['output'];
  finishes: Array<AppliedFinish>;
  label?: Maybe<Scalars['String']['output']>;
  /** Dimensions of panel as used in Optimization without margins */
  optimizationDimensions: OptimizationDimensions;
  shape: Shape;
};

export type AddressSuggestionsQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  cartId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddressSuggestionsQuery = (
  { __typename?: 'Query' }
  & { addressSuggestions?: Maybe<Array<Maybe<(
    { __typename?: 'AddressSuggestionResult' }
    & Pick<AddressSuggestionResult, 'value' | 'label' | 'description' | 'precision' | 'context'>
  )>>> }
);

export type AddressSuggestionDetailQueryVariables = Exact<{
  context: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type AddressSuggestionDetailQuery = (
  { __typename?: 'Query' }
  & { addressSuggestionDetail?: Maybe<(
    { __typename?: 'AddressSuggestionDetailResult' }
    & Pick<AddressSuggestionDetailResult, 'valid' | 'city' | 'street' | 'postcode' | 'number' | 'numberAddition'>
  )> }
);

export type CalculatePriceQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  data: Scalars['String']['input'];
}>;


export type CalculatePriceQuery = (
  { __typename?: 'Query' }
  & { calculatePrice: (
    { __typename?: 'Money' }
    & Pick<Money, 'currency' | 'display' | 'includingTax' | 'excludingTax'>
  ) }
);

export type CategoryVariantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CategoryVariantQuery = (
  { __typename?: 'Query' }
  & { category?: Maybe<(
    { __typename?: 'Category' }
    & Pick<Category, 'displayType'>
  )> }
);

export type SendContactMutationVariables = Exact<{
  input: ContactInput;
}>;


export type SendContactMutation = (
  { __typename?: 'Mutation' }
  & { sendContact?: Maybe<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'success' | 'message'>
  )> }
);

export type SendStylistContactMutationVariables = Exact<{
  input: StylistContactInput;
}>;


export type SendStylistContactMutation = (
  { __typename?: 'Mutation' }
  & { sendStylistContact?: Maybe<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'success' | 'message'>
  )> }
);

export type ContactSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactSettingsQuery = (
  { __typename?: 'Query' }
  & { contactSettings?: Maybe<(
    { __typename?: 'ContactSettings' }
    & { subjects?: Maybe<Array<Maybe<(
      { __typename?: 'ContactSubject' }
      & Pick<ContactSubject, 'label' | 'value' | 'category'>
    )>>> }
  )> }
);

export type ProductAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type ProductAlertMutation = (
  { __typename?: 'Mutation' }
  & { productAlert?: Maybe<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'success' | 'message'>
  )> }
);

export type SendBloggersContactMutationVariables = Exact<{
  input: BloggersContactInput;
}>;


export type SendBloggersContactMutation = (
  { __typename?: 'Mutation' }
  & { sendBloggersContact?: Maybe<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'success' | 'message'>
  )> }
);

export type EditOrderRequestMutationVariables = Exact<{
  input: EditOrderRequestInput;
}>;


export type EditOrderRequestMutation = (
  { __typename?: 'Mutation' }
  & { editOrderRequest?: Maybe<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'success' | 'message'>
  )> }
);

export type OrderEditableQueryVariables = Exact<{
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type OrderEditableQuery = (
  { __typename?: 'Query' }
  & { orderEditable?: Maybe<(
    { __typename?: 'OrderEditable' }
    & Pick<OrderEditable, 'editable' | 'message'>
  )> }
);

export type GroupedProductsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GroupedProductsQuery = (
  { __typename?: 'Query' }
  & { products: (
    { __typename?: 'Products' }
    & { items: Array<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'name' | 'isSalable'>
    )> }
  ) }
);

export type ProductVariantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductVariantQuery = (
  { __typename?: 'Query' }
  & { product?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'attributeSet'>
  )> }
);


export const AddressSuggestionsDocument = gql`
    query addressSuggestions($searchTerm: String!, $context: String, $countryCode: String!, $cartId: ID) {
  addressSuggestions(
    searchTerm: $searchTerm
    context: $context
    countryCode: $countryCode
    cartId: $cartId
  ) {
    value
    label
    description
    precision
    context
  }
}
    `;
export type AddressSuggestionsQueryResult = Apollo.QueryResult<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>;
export const AddressSuggestionDetailDocument = gql`
    query addressSuggestionDetail($context: String!, $countryCode: String!) {
  addressSuggestionDetail(context: $context, countryCode: $countryCode) {
    valid
    city
    street
    postcode
    number
    numberAddition
  }
}
    `;
export type AddressSuggestionDetailQueryResult = Apollo.QueryResult<AddressSuggestionDetailQuery, AddressSuggestionDetailQueryVariables>;
export const CalculatePriceDocument = gql`
    query CalculatePrice($productId: ID!, $data: String!) {
  calculatePrice(productId: $productId, data: $data) {
    currency
    display
    includingTax
    excludingTax
  }
}
    `;
export type CalculatePriceQueryResult = Apollo.QueryResult<CalculatePriceQuery, CalculatePriceQueryVariables>;
export const CategoryVariantDocument = gql`
    query CategoryVariant($id: ID!) {
  category(id: $id) {
    displayType
  }
}
    `;
export type CategoryVariantQueryResult = Apollo.QueryResult<CategoryVariantQuery, CategoryVariantQueryVariables>;
export const SendContactDocument = gql`
    mutation SendContact($input: ContactInput!) {
  sendContact(input: $input) {
    success
    message
  }
}
    `;
export type SendContactMutationFn = Apollo.MutationFunction<SendContactMutation, SendContactMutationVariables>;
export type SendContactMutationResult = Apollo.MutationResult<SendContactMutation>;
export type SendContactMutationOptions = Apollo.BaseMutationOptions<SendContactMutation, SendContactMutationVariables>;
export const SendStylistContactDocument = gql`
    mutation SendStylistContact($input: StylistContactInput!) {
  sendStylistContact(input: $input) {
    success
    message
  }
}
    `;
export type SendStylistContactMutationFn = Apollo.MutationFunction<SendStylistContactMutation, SendStylistContactMutationVariables>;
export type SendStylistContactMutationResult = Apollo.MutationResult<SendStylistContactMutation>;
export type SendStylistContactMutationOptions = Apollo.BaseMutationOptions<SendStylistContactMutation, SendStylistContactMutationVariables>;
export const ContactSettingsDocument = gql`
    query ContactSettings {
  contactSettings {
    subjects {
      label
      value
      category
    }
  }
}
    `;
export type ContactSettingsQueryResult = Apollo.QueryResult<ContactSettingsQuery, ContactSettingsQueryVariables>;
export const ProductAlertDocument = gql`
    mutation ProductAlert($id: ID!, $email: String!) {
  productAlert(id: $id, email: $email) {
    success
    message
  }
}
    `;
export type ProductAlertMutationFn = Apollo.MutationFunction<ProductAlertMutation, ProductAlertMutationVariables>;
export type ProductAlertMutationResult = Apollo.MutationResult<ProductAlertMutation>;
export type ProductAlertMutationOptions = Apollo.BaseMutationOptions<ProductAlertMutation, ProductAlertMutationVariables>;
export const SendBloggersContactDocument = gql`
    mutation SendBloggersContact($input: BloggersContactInput!) {
  sendBloggersContact(input: $input) {
    success
    message
  }
}
    `;
export type SendBloggersContactMutationFn = Apollo.MutationFunction<SendBloggersContactMutation, SendBloggersContactMutationVariables>;
export type SendBloggersContactMutationResult = Apollo.MutationResult<SendBloggersContactMutation>;
export type SendBloggersContactMutationOptions = Apollo.BaseMutationOptions<SendBloggersContactMutation, SendBloggersContactMutationVariables>;
export const EditOrderRequestDocument = gql`
    mutation EditOrderRequest($input: EditOrderRequestInput!) {
  editOrderRequest(input: $input) {
    success
    message
  }
}
    `;
export type EditOrderRequestMutationFn = Apollo.MutationFunction<EditOrderRequestMutation, EditOrderRequestMutationVariables>;
export type EditOrderRequestMutationResult = Apollo.MutationResult<EditOrderRequestMutation>;
export type EditOrderRequestMutationOptions = Apollo.BaseMutationOptions<EditOrderRequestMutation, EditOrderRequestMutationVariables>;
export const OrderEditableDocument = gql`
    query OrderEditable($email: String!, $id: ID!, $type: String!) {
  orderEditable(email: $email, id: $id, type: $type) {
    editable
    message
  }
}
    `;
export type OrderEditableQueryResult = Apollo.QueryResult<OrderEditableQuery, OrderEditableQueryVariables>;
export const GroupedProductsDocument = gql`
    query GroupedProducts($id: ID!) {
  products(filter: {category_id: $id, type_id: "grouped"}, pageSize: 1000) {
    items {
      id
      name
      isSalable
    }
  }
}
    `;
export type GroupedProductsQueryResult = Apollo.QueryResult<GroupedProductsQuery, GroupedProductsQueryVariables>;
export const ProductVariantDocument = gql`
    query ProductVariant($id: ID!) {
  product(id: $id) {
    attributeSet
  }
}
    `;
export type ProductVariantQueryResult = Apollo.QueryResult<ProductVariantQuery, ProductVariantQueryVariables>;